<script setup>
import {ref} from "vue";

const props = defineProps({
    formId: {
        type: Number,
        required: true,
    }
})

const submissionList = ref(null)
const form = ref({ id: '', title: '' })

const onFormLoaded = (formData) => {
    form.value = formData
}
</script>
<template>
    <div>
        <div class="md:sticky top-2 z-topbar">
            <frosted-bar>
                <div class="flex items-center justify-between space-x-4">
                    <h1>
                        <a
                            :href="route('forms.edit', form.id)"
                            class="mf-link"
                        >
                            {{ form.title }}
                        </a>
                    </h1>
                </div>
            </frosted-bar>
        </div>

        <form-submissions-list
            class="mt-12"
            ref="submissionList"
            :form-id="formId"
            @form-loaded="onFormLoaded"
        />
    </div>
</template>
